import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { TicketWorkspaceRecordsTable } from "@/features/tickets/components/ticket-workspace-records-table";
import { isNestedRecordWorkspacePath } from "@/features/tickets/lib/is-nested-record-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records",
)({
	component: TicketWorkspaceRecordsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Job workspace Records tab — table shell with outlet for record drawer / nested workspace.
 */
function TicketWorkspaceRecordsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedRecordWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<TicketWorkspaceRecordsTable
				orgId={params.orgId}
				ticketId={params.ticketId}
			/>
			<Outlet />
		</div>
	);
}
